export const uuid = () => crypto.randomUUID();
